import React, { useEffect } from 'react';
import WatchAndWhitelistTable from '../../../../../components/ns/WatchAndWhitelistTable';
import PropTypes from 'prop-types';
import Wait4Me from '../../../../../components/Wait4Me';
import styles from './index.scss';

import { checkAccess } from '../../../../common/utils/index';

const resourceCode = 'APP_3_RESOURCE_UI_NS_IAD_MATCHING_RUN_INSTANCE';

const SelectWatchList = (props) => {
  const { apiActions = {}, settings, authentication } = props;
  const { getNSRIWatchListInitiate = {} } = apiActions;

  // Side Effects
  useEffect(() => {
    // WatchList API
    getNSRIWatchListInitiate({});
  }, []);

  // To Get Global Settings Configuration
  const getGSConfig = (q) => {
    if (settings?.nsSetting?.data?.uiWidgetGroups) {
      const groups = settings.nsSetting.data.uiWidgetGroups;
      return groups
        .find((g) => g.widgetGroupId === q.widgetGroupId)
        ?.widgets.find((w) => w.widgetId === q.widgetId);
    }
    return {};
  };

  // Global Settings config
  const GS = getGSConfig({
    widgetGroupId: 'NS_IAD_LIST_WATCHLISTS',
    widgetId: 'NS_IAD_LIST_WATCHLISTS'
  });

  return (
    <div className={styles.watchListContainer}>
      {settings?.nsSetting?.isLoading ? (
        <div className={styles.loadingWrapper}>
          <Wait4Me />
        </div>
      ) : (
        <WatchAndWhitelistTable
          {...props}
          GS={GS}
          hasRowSelection={true}
          hasPagination={true}
          component="SelectWatchList"
          hasExecuteAccessToSelect={checkAccess(
            authentication,
            resourceCode,
            'Write'
          )}
        />
      )}
    </div>
  );
};

SelectWatchList.propTypes = {
  apiActions: PropTypes.object.isRequired
};

export default SelectWatchList;
